import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface RemunerationGroupsParams {
  direction: 'INBOUND' | 'OUTBOUND' | 'ALL';
  year: number;
  receivingPpo: string;
}

export interface RemunerationGroupRow {
  id: number | null;
  sendingPpo: {
    id: number;
    name: string;
    longName: string | null;
    disabled: boolean;
  };
  receiver: {
    id: number | null;
    remunerationGroup: {
      id: number;
      name: string;
      operator: any | null;
      displayName: string;
      predefined: boolean;
      homeCountry: boolean;
    };
    receivingPpo: {
      id: number;
      name: string;
      longName: string | null;
      disabled: boolean;
    };
    year: number;
    notSubjToSampling: boolean;
  };
  quarter: number;
  latestActivityPpo: any | null;
  latestActivityTime: string | null;
  year: number;
  receivingPpo: {
    id: number;
    name: string;
    longName: string | null;
    disabled: boolean;
  };
  notSubjToSampling: boolean;
  remunerationGroup: {
    id: number;
    name: string;
    operator: any | null;
    displayName: string;
    predefined: boolean;
    homeCountry: boolean;
  };
  hasComments: boolean;
  impcEntities?: Array<{
    id: number;
    name: string;
    exchangeOffice: {
      id: number;
      name: string;
      longName: string;
      disabled: boolean;
    };
    excludeFromUnex: boolean;
    etoe: boolean;
  }>;
}

export interface RemunerationGroupsResponse {
  // For HTML format, contains the table data
  data?: RemunerationGroupRow[];
  url?: string;
  content?: Blob;
  filename?: string; // Add filename field for PDF/XLS downloads
}

export function useRemunerationGroups() {
  return useMutation<RemunerationGroupsResponse, Error, RemunerationGroupsParams>({
    mutationFn: async (params: RemunerationGroupsParams) => {
      // Create URLSearchParams to handle query parameters
      const searchParams = new URLSearchParams();
      
      // Add direction parameter
      searchParams.append('direction', params.direction);
      
      // Add year parameter
      searchParams.append('year', params.year.toString());
      
      // Add receivingPpo parameter
      searchParams.append('receivingPpo', params.receivingPpo);

      const response = await axios.get(`/upu-rg?${searchParams.toString()}`, {
        // HTML returns JSON with table data, PDF/XLS return binary files
        responseType: 'json',
      });

      // For now, we'll assume the API returns JSON data
      // You can extend this to handle different response types if needed
      return { data: response.data };
    },
  });
} 